import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "FormSelect" }

import { PropType } from "vue";
import { FormValue } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSelect',
  props: {
    item: {
        type: Object,
        required: true,
    },
    value: {
        type: Object as PropType<FormValue>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_select, {
      items: __props.item.options,
      modelValue: __props.value[__props.item.key],
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.value[__props.item.key]) = $event)),
      "item-title": __props.item.labelKey,
      "item-value": __props.item.valueKey
    }, null, 8, ["items", "modelValue", "item-title", "item-value"])
  ]))
}
}

})